import styled from 'styled-components';
import { fadeIn } from '../../styles/animations';
import Flex from './Flex';

export const Container = styled(Flex)`
  width: 100%;
  margin: 0rem 4rem 1rem 4rem;
  animation: ${fadeIn} 0.4s;
`;
